<template>
  <div class="guess-face-challenge">
    <!-- Name Display -->
    <div class="name-container mb-6">
      <div class="name-display">
        {{ challenge.nameToMatch }}
      </div>
    </div>

    <!-- Photo Options -->
    <div class="photos-grid">
      <button
        v-for="option in challenge.options"
        :key="option.id"
        :disabled="!!feedback"
        class="photo-option"
        :class="getPhotoClass(option.id)"
        @click="selectAnswer(option.id)"
      >
        <img :src="option.photoUrl" :alt="option.name" class="option-photo">
        <div v-if="getPhotoClass(option.id).includes('correct-answer')" class="photo-overlay">
          <div class="overlay-check">✓</div>
        </div>
        <div v-if="getPhotoClass(option.id).includes('wrong-answer')" class="photo-overlay error">
          <div class="overlay-x">✗</div>
        </div>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  challenge: Object,
  feedback: Object
})

const emit = defineEmits(['answer'])

const selectedAnswer = ref(null)

function selectAnswer(optionId) {
  if (selectedAnswer.value || props.feedback) return

  selectedAnswer.value = optionId
  emit('answer', optionId)
}

function getPhotoClass(optionId) {
  const classes = ['photo-btn']

  if (props.feedback) {
    if (optionId === props.challenge.correctAnswer) {
      classes.push('correct-answer')
    } else if (optionId === selectedAnswer.value && !props.feedback.isCorrect) {
      classes.push('wrong-answer')
    } else {
      classes.push('disabled')
    }
  } else if (selectedAnswer.value === optionId) {
    classes.push('selected')
  }

  return classes
}
</script>

<style scoped>
.guess-face-challenge {
  @apply space-y-6;
}

.name-container {
  @apply text-center;
}

.name-display {
  @apply text-2xl font-bold text-primary bg-secondary-fixed rounded-lg py-4 px-6 inline-block;
}

.photos-grid {
  @apply grid grid-cols-2 gap-4;
}

.photo-option {
  @apply relative rounded-lg overflow-hidden border-4 border-gray-200 hover:border-accent transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2;
}

.photo-option:disabled {
  @apply cursor-not-allowed;
}

.option-photo {
  @apply w-full h-32 sm:h-40 object-cover;
}

.photo-btn.selected {
  @apply border-accent;
}

.photo-btn.correct-answer {
  @apply border-green-500;
}

.photo-btn.wrong-answer {
  @apply border-red-500;
}

.photo-btn.disabled {
  @apply opacity-50;
}

.photo-overlay {
  @apply absolute inset-0 bg-green-500/80 flex items-center justify-center;
}

.photo-overlay.error {
  @apply bg-red-500/80;
}

.overlay-check,
.overlay-x {
  @apply text-white text-4xl font-bold;
}

.feedback-section {
  @apply mt-6 text-center;
}

.feedback-message {
  @apply inline-flex items-center gap-3 px-4 py-3 rounded-lg;
}

.feedback-message.correct {
  @apply bg-green-100 text-green-800;
}

.feedback-message.incorrect {
  @apply bg-red-100 text-red-800;
}

.feedback-icon {
  @apply text-2xl font-bold;
}

.feedback-title {
  @apply font-semibold;
}

.xp-gained {
  @apply text-sm font-medium;
}
</style>
